import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const AutoRejectHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Auto-Reject Criteria
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Set up automated screening criteria to efficiently filter out unqualified candidates.
            Save time by automatically rejecting applications that don't meet your basic requirements.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Criteria Setup
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Define specific criteria for automatic rejection, such as minimum qualifications,
            required skills, or location requirements. Set up multiple criteria for different job types.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Custom Rules
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Create custom rules based on application responses, resume content, or assessment
            results. Combine multiple criteria to create complex screening rules.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Notification Settings
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Configure how rejected candidates are notified. Customize rejection emails and
            ensure candidates receive timely and professional communication.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Review Process
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Review and adjust your auto-reject criteria regularly. Monitor the effectiveness
            of your screening rules and make improvements based on hiring outcomes.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/automation/auto-reject/criteria"
              color="primary"
              variant="contained"
            >
              Configure Auto-Reject Rules
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default AutoRejectHelp; 